//#region Get Course Select List

import { SelectListDto } from "../../models";

export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATES_SUCCESS: any = "GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_ERROR: any = "GET_TEMPLATES_ERROR";
export const RESET_TEMPLATES: any = "RESET_TEMPLATES";

export interface GetTemplatesAction {
  type: typeof GET_TEMPLATES;
  payload: null;
}

export interface GetTemplatesSuccessAction {
  type: typeof GET_TEMPLATES_SUCCESS;
  payload: SelectListDto[];
}

export interface GetTemplatesErrorAction {
  type: typeof GET_TEMPLATES_ERROR;
  payload: any;
}

export interface ResetTemplatesAction {
  type: typeof RESET_TEMPLATES;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetTemplatesAction
  | GetTemplatesSuccessAction
  | GetTemplatesErrorAction
  | ResetTemplatesAction;
